export function archiveButtonDataTip(isActive, isArchive) {
    if (isActive !== undefined) {
      return isActive ? "Archive" : "Unarchive";
    }
    if (isArchive !== undefined) {
      return isArchive ? "Unarchive" : "Archive";
    }
    return "Archive";
  }
  